















































import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportService from '@/api/CustomerImportService';

import CustomerImportIlustra from '@/components/icons/CustomerImportIlustra.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import { ECustomerImportProgressStatus } from '@/models/customer-import';

let timer: NodeJS.Timeout;
const POLLING_TIME = 2000; // 2s

@Component<CustomerImportInProgress>({
  components: {
    CustomerImportIlustra,
    GhostButton
  },
  computed: {
    percentageCalc() {
      const { imported, total } = this.progress;

      if (!total) return '0%';

      return `${(imported * 100) / total}%`;
    }
  }
})
export default class CustomerImportInProgress extends Vue {
  @Prop({ default: true }) showKeepExploringButton?: boolean;
  @Prop({ default: false }) modal?: boolean;
  @Prop(Number) totalCustomersToImport?: number;
  @Prop(Number) totalImportedCustomers?: number;

  loading = !this.totalImportedCustomers;
  customerImportService = new CustomerImportService();
  progress = {
    imported: this.totalImportedCustomers || 0,
    total: this.totalCustomersToImport || 0,
    percentage: 0
  };
  completed = false;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  async customerImportStatus() {
    let scopedStatus = '';

    try {
      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      const { success, status, current: imported, total } = data;

      scopedStatus = status;

      if (!success) {
        clearTimeout(timer);
        this.$emit('failed', data);

        this.$analytics({
          eventCategory: `Import Members Modals | Member Import Error`,
          eventAction: 'click',
          eventLabel: `An error occurred`
        });

        return;
      }

      if (scopedStatus === ECustomerImportProgressStatus.DONE) {
        clearTimeout(timer);
        this.completed = true;
        setTimeout(() => {
          this.$emit('completed', data);
        }, 700);

        return;
      }

      this.loading =
        scopedStatus !== ECustomerImportProgressStatus.IMPORTING || !total;

      Object.assign(this.progress, {
        total,
        imported
      });
    } finally {
      if (scopedStatus !== ECustomerImportProgressStatus.DONE) {
        timer = setTimeout(this.customerImportStatus, POLLING_TIME);
      }
    }
  }

  mounted() {
    this.customerImportStatus();
  }

  beforeDestroy() {
    clearTimeout(timer);
  }
}
